import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as common from '../../../../../common'

export const DOC = gql`
  ${common.gql.dms.data.fragments.variableValue.DOC}
  fragment FragmentMosaicUiSetVariablesActionRendering on MosaicUiSetVariablesActionRendering {
    variables {
      ...FragmentVariableValue
    }
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentMosaicUiSetVariablesActionRenderingFragment,
  ents.core.mosaic.Action.Rendering<ents.core.mosaic.Action.Operation.UiSetVariables>
>({
  operation: () => ents.core.mosaic.Action.Operation.UiSetVariables,
  payload: {
    usingFullInput: graphql.transformers.OUT.object<
      graphql.schema.FragmentMosaicUiSetVariablesActionRenderingFragment,
      ents.core.mosaic.Action.Payload<ents.core.mosaic.Action.Operation.UiSetVariables>
    >({
      variables: graphql.transformers.OUT.validate(
        common.gql.dms.data.fragments.variableValue.LOOKUP_TRANSFORMER,
        TypeAsserter.assertIsNotNullish,
        { warnOnly: true },
      ),
    }),
  },
})
